import { navigate } from '@reach/router';

export const onContinue = (
  clubId: string,
  eventId: string,
  roundId: string,
  section: string
) => () => navigate(`/staff/club/${clubId}/event/${eventId}/round/${roundId}/${section}`);
